import { CSSObject, styled, Theme } from "@mui/material/styles";

import { Drawer as MuiDrawer } from "../../UI/Drawer";
import { ListItemButton } from "../../UI/ListItemButton";
import { COLOR_FIORD, COLOR_PATTERNS_BLUE, COLOR_SCIENCE_BLUE } from "../../constants/styles";
import { getStagingColor } from "../../constants/stagingconfig";

export const DRAWER_WIDTH = 260;

const openedMixin = (theme: Theme): CSSObject => ({
  width: DRAWER_WIDTH,
  borderRight: 0,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflow: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  borderRight: 0,
  overflow: "hidden",
  width: theme.spacing(7.5),
});

export const StyledDrawer = styled(MuiDrawer)(({ theme, open }) => ({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  boxShadow: theme.shadows[1],
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(0, 1),
  backgroundColor: getStagingColor(),
  // necessary for content to be below app bar
  ...(theme.mixins.toolbar as any),
}));

export const StyledListItemButton = styled(ListItemButton)`
  height: 40px;
  margin-bottom: 12px;
  margin-left: ${(props) => props.theme.spacing(1.5)};
  margin-right: ${(props) => props.theme.spacing(1)};
  border-radius: 3px;
  padding: ${(props) => props.theme.spacing(1)};

  & .MuiListItemIcon-root {
    min-width: 24px;
    margin-right: ${(props) => props.theme.spacing(2)};
  }

  & .MuiListItemText-primary {
    font-size: 14px;
    color: ${COLOR_FIORD};
  }

  &.Mui-selected {
    background-color: ${COLOR_PATTERNS_BLUE};

    & .MuiListItemText-primary {
      font-weight: 500;
      color: ${COLOR_SCIENCE_BLUE};
    }
  }
`;
